import { Icon, IconButton, Menu, MenuButton, MenuItem, MenuList } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { FiMoreHorizontal, FiTrash2 } from "react-icons/fi";

export const MarketDialogueActionsMenu = ({ onDelete }: { onDelete?: () => void }) => {
  const { t } = useTranslation();
  if (!onDelete) return null;
  return (
    <Menu>
      <MenuButton
        as={IconButton}
        size="sm"
        variant="outline"
        aria-label={t("Actions") ?? "Actions"}
        icon={<Icon as={FiMoreHorizontal} />}
      />
      <MenuList>
        <MenuItem color="smError" icon={<Icon as={FiTrash2} />} onClick={onDelete}>
          {t("Delete draft")}
        </MenuItem>
      </MenuList>
    </Menu>
  );
};
